var blockquote_default = {
  "fontElementMap": "_1GLUV",
  "quote": "v2efZ"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
